import PropTypes from 'prop-types';
import React from 'react';
import NextSteps from './NextSteps';
import Question from './Question';
import Result from './Result';
import Section from './Section';

class Slide extends React.Component {
	constructor(props) {
		super(props);
	}

	getSlideContent = (type) => {
		const { contacts, slide, slides, labels, handleChange, handleSliderChange, dimensions, userInput, userData } = this.props;
		switch (type) {
			case 'content':
				return <Section image={slide.image} title={slide.title} text={slide.text} />;
			case 'question':
				return <Question userInput={userInput} question={slide} labels={labels} handleChange={handleChange} handleSliderChange={handleSliderChange} />;
			case 'results':
				return (
					<Result
						labels={labels}
						image={slide.image}
						highscoreContent={slide.highscore}
						dimensions={dimensions}
						userData={userData}
						contacts={contacts}
						updateUserContact={this.props.updateUserContact}
					/>
				);
			case 'next_steps':
				return <NextSteps {...slide} userData={userData} slides={slides} dimensions={dimensions} />;
		}
	};

	render() {
		return (
			<div id="slide" className="ms-form__slide">
				{this.getSlideContent(this.props.slide.type)}
			</div>
		);
	}
}

export default Slide;

Slide.propTypes = {
	contacts: PropTypes.object,
	dimensions: PropTypes.object,
	handleChange: PropTypes.func,
	handleSliderChange: PropTypes.func,
	labels: PropTypes.object,
	slide: PropTypes.object,
	slides: PropTypes.array,
	updateUserContact: PropTypes.func,
	userData: PropTypes.object,
	userInput: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.array]),
};
